import { useEffect, useState } from "react";
import axios from "axios";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const imgUrl = (item) =>
  item.url && item.url.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${item.url}` : item.url;

export const Gallery = () => {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/gallery`)
      .then((r) => setItems(r.data))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <section id="gallery" data-testid="gallery-section" className="border-t border-white/10 px-5 py-20 sm:px-8 lg:px-12 lg:py-28">
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-turquoise">03 — Our Work</p>
            <h2 className="font-heading mt-4 text-3xl font-black uppercase tracking-tight sm:text-4xl lg:text-5xl">
              Proof, <span className="text-volt">not promises</span>
            </h2>
          </div>
          <p className="max-w-xs text-xs uppercase tracking-[0.2em] text-white/40">
            A few of the buildings we've raised. New projects added regularly.
          </p>
        </div>
      </Reveal>

      <div data-testid="gallery-grid" className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((item, i) => (
          <Reveal key={item.id} delay={(i % 3) * 0.08}>
            <figure data-testid={`gallery-item-${i}`} className="group">
              <div className={`overflow-hidden border border-white/10 ${i % 3 === 1 ? "aspect-[3/4]" : "aspect-[4/3]"}`}>
                <img
                  src={imgUrl(item)}
                  alt={item.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
              <figcaption className="mt-3 flex items-baseline justify-between gap-4">
                <span className="font-heading text-sm font-bold uppercase tracking-wider">{item.title}</span>
                <span className="shrink-0 text-[10px] uppercase tracking-[0.25em] text-white/40">{item.category}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      {loaded && items.length === 0 && (
        <p data-testid="gallery-empty" className="mt-14 border border-white/10 p-10 text-center text-sm uppercase tracking-[0.2em] text-white/40">
          Project photos coming soon — we're out raising steel.
        </p>
      )}
    </section>
  );
};
